/* template */
<template><Drawer :show="(value)" @close="onClose" :title="(title)" closeable showMask centerTitle :headerStyle="(headerStyle)" class="city-drawer"><CityList :bizType="(bizType)" @confirm="cityConfirm" class="city-container"/></Drawer></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"md7a651ac"}'>
.city-drawer
  >>> .drawer-container
    height 85vh
    .header
      font-family PingFangSC-Medium
      font-weight 500
  .city-container
    >>> .search.mpx-input
      border none
      outline none
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "md7a651ac"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexd7a651ac%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexd7a651ac%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["md7a651ac"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexd7a651ac/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'Drawer':getComponent(require("../../../node_modules/@didi/spring-ui/ts-drawer/index.mpx?isComponent&outputPath=components%2Findex76c11e5c%2Findex")),'CityList':getComponent(require("../../../node_modules/@didi/spring-ui/citySelect/index.mpx?isComponent&outputPath=components%2Findexad642744%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
